import { jsx as i, jsxs as T } from "react/jsx-runtime";
import * as t from "react";
import { u as U, c as g, a as C } from "../../index-DcwNtM_b.js";
import { u as I } from "../../index-5Bhkapwi.js";
import { P as h } from "../../index-CpDnqHCm.js";
import { c as _, R as V, I as j } from "../../index-BJirOIk2.js";
import { u as z } from "../../index-TA5H0I__.js";
import { u as H } from "../../index-Ck1TnIqh.js";
import { u as $ } from "../../index-BZPx6jYI.js";
import { P as W } from "../../index-DBEov9sD.js";
import { c as P } from "../../utils-BOFVZgHd.js";
import { c as X } from "../../createLucideIcon-BuuoCVvz.js";
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], J = X("circle", Y);
var N = "Radio", [Q, E] = g(N), [Z, ee] = Q(N), k = t.forwardRef(
  (r, n) => {
    const {
      __scopeRadio: e,
      name: s,
      checked: o = !1,
      required: a,
      disabled: c,
      value: p = "on",
      onCheck: f,
      form: m,
      ...v
    } = r, [l, R] = t.useState(null), d = I(n, (b) => R(b)), u = t.useRef(!1), y = l ? m || !!l.closest("form") : !0;
    return /* @__PURE__ */ T(Z, { scope: e, checked: o, disabled: c, children: [
      /* @__PURE__ */ i(
        h.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": x(o),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: p,
          ...v,
          ref: d,
          onClick: C(r.onClick, (b) => {
            o || f?.(), y && (u.current = b.isPropagationStopped(), u.current || b.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ i(
        A,
        {
          control: l,
          bubbles: !u.current,
          name: s,
          value: p,
          checked: o,
          required: a,
          disabled: c,
          form: m,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
k.displayName = N;
var G = "RadioIndicator", S = t.forwardRef(
  (r, n) => {
    const { __scopeRadio: e, forceMount: s, ...o } = r, a = ee(G, e);
    return /* @__PURE__ */ i(W, { present: s || a.checked, children: /* @__PURE__ */ i(
      h.span,
      {
        "data-state": x(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: n
      }
    ) });
  }
);
S.displayName = G;
var oe = "RadioBubbleInput", A = t.forwardRef(
  ({
    __scopeRadio: r,
    control: n,
    checked: e,
    bubbles: s = !0,
    ...o
  }, a) => {
    const c = t.useRef(null), p = I(c, a), f = $(e), m = H(n);
    return t.useEffect(() => {
      const v = c.current;
      if (!v) return;
      const l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(
        l,
        "checked"
      ).set;
      if (f !== e && d) {
        const u = new Event("click", { bubbles: s });
        d.call(v, e), v.dispatchEvent(u);
      }
    }, [f, e, s]), /* @__PURE__ */ i(
      h.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: e,
        ...o,
        tabIndex: -1,
        ref: p,
        style: {
          ...o.style,
          ...m,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
A.displayName = oe;
function x(r) {
  return r ? "checked" : "unchecked";
}
var re = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], w = "RadioGroup", [ae, Ce] = g(w, [
  _,
  E
]), D = _(), M = E(), [te, ie] = ae(w), L = t.forwardRef(
  (r, n) => {
    const {
      __scopeRadioGroup: e,
      name: s,
      defaultValue: o,
      value: a,
      required: c = !1,
      disabled: p = !1,
      orientation: f,
      dir: m,
      loop: v = !0,
      onValueChange: l,
      ...R
    } = r, d = D(e), u = z(m), [y, b] = U({
      prop: a,
      defaultProp: o ?? null,
      onChange: l,
      caller: w
    });
    return /* @__PURE__ */ i(
      te,
      {
        scope: e,
        name: s,
        required: c,
        disabled: p,
        value: y,
        onValueChange: b,
        children: /* @__PURE__ */ i(
          V,
          {
            asChild: !0,
            ...d,
            orientation: f,
            dir: u,
            loop: v,
            children: /* @__PURE__ */ i(
              h.div,
              {
                role: "radiogroup",
                "aria-required": c,
                "aria-orientation": f,
                "data-disabled": p ? "" : void 0,
                dir: u,
                ...R,
                ref: n
              }
            )
          }
        )
      }
    );
  }
);
L.displayName = w;
var O = "RadioGroupItem", F = t.forwardRef(
  (r, n) => {
    const { __scopeRadioGroup: e, disabled: s, ...o } = r, a = ie(O, e), c = a.disabled || s, p = D(e), f = M(e), m = t.useRef(null), v = I(n, m), l = a.value === o.value, R = t.useRef(!1);
    return t.useEffect(() => {
      const d = (y) => {
        re.includes(y.key) && (R.current = !0);
      }, u = () => R.current = !1;
      return document.addEventListener("keydown", d), document.addEventListener("keyup", u), () => {
        document.removeEventListener("keydown", d), document.removeEventListener("keyup", u);
      };
    }, []), /* @__PURE__ */ i(
      j,
      {
        asChild: !0,
        ...p,
        focusable: !c,
        active: l,
        children: /* @__PURE__ */ i(
          k,
          {
            disabled: c,
            required: a.required,
            checked: l,
            ...f,
            ...o,
            name: a.name,
            ref: v,
            onCheck: () => a.onValueChange(o.value),
            onKeyDown: C((d) => {
              d.key === "Enter" && d.preventDefault();
            }),
            onFocus: C(o.onFocus, () => {
              R.current && m.current?.click();
            })
          }
        )
      }
    );
  }
);
F.displayName = O;
var ne = "RadioGroupIndicator", B = t.forwardRef(
  (r, n) => {
    const { __scopeRadioGroup: e, ...s } = r, o = M(e);
    return /* @__PURE__ */ i(S, { ...o, ...s, ref: n });
  }
);
B.displayName = ne;
var q = L, K = F, se = B;
const ce = t.forwardRef(({ className: r, ...n }, e) => /* @__PURE__ */ i(q, { className: P("grid gap-2", r), ref: e, ...n }));
ce.displayName = q.displayName;
const de = t.forwardRef(({ className: r, children: n, ...e }, s) => /* @__PURE__ */ i(
  K,
  {
    ref: s,
    className: P(
      "relative h-4 w-4 rounded-full border border-[var(--border)]",
      "text-[var(--primary)]",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "transition-colors duration-200",
      r
    ),
    ...e,
    children: /* @__PURE__ */ i(se, { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ i(J, { className: "h-2.5 w-2.5 fill-[var(--primary)] text-[var(--primary)]" }) })
  }
));
de.displayName = K.displayName;
export {
  ce as RadioGroup,
  de as RadioGroupItem
};
//# sourceMappingURL=radio-group.js.map
